import React, { useEffect, FC, useRef, useState, useLayoutEffect, useCallback } from 'react';
import { css } from 'aphrodite/no-important';

// util
import { CloseIcon } from '../../../util/icons';

// models
import { ChatUser } from './LiveChat.types';

// styles
import { style } from './style';

// components
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { useEventListener } from '../../hooks';

const TABLET_WIDTH = 768;
interface Props {
  showChat: boolean;
  userData: ChatUser;
  onRequestClose: () => void;
}
export const LiveChatPreview: FC<Props> = ({ showChat, userData, onRequestClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < TABLET_WIDTH);
  const styles = style({ isActive: showChat });
  let scrollPosition = useRef<any>();

  // If the chat is opened in mobile (fullscreen), then we need to prevent background scrolling,
  // but we should not lock scroll on tablet or desktop
  const resizeHandler = useCallback(() => {
    window.innerWidth < TABLET_WIDTH ? setIsMobile(true) : setIsMobile(false);
  }, []);
  useEventListener('resize', resizeHandler);

  // Triggered when CometChat has finished loading
  const onChatLoad = () => {
    setIsLoading(false);
  };

  const handleClose = () => {
    // Unlock body scrolling and restore the scroll position
    const $body = document.body;
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition.current || 0);

    onRequestClose();
  };

  useLayoutEffect(() => {
    const $body = document.body;
    if (showChat && isMobile) {
      // Save the user's current scroll position so that when the modal is closed the user will be at the same position
      scrollPosition.current = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      $body.style.width = '100%';
      $body.style.top = `-${scrollPosition.current}px`;
    }
  }, [isMobile, showChat]);

  useEffect(() => {
    setTimeout(() => {
      onChatLoad();
    }, 1000);
  }, []);
  return (
    <>
      <div className={css(styles.chatContainer, showChat ? styles.chatOpen : styles.chatClosed)}>
        <div className={css(styles.header)}>
          <span>LIVE CHAT</span>
          <button className={css(styles.closeButton)} onClick={handleClose}>
            <CloseIcon></CloseIcon>
          </button>
        </div>

        <div className={css(styles.cometChat)}>
          {isLoading && (
            <div className={css(styles.loadingSpinner)}>
              <LoadingSpinner></LoadingSpinner>
            </div>
          )}
          <div className={css(styles.tsChat)}>
            <div className={css(styles.userInfo)}>
              <div className={css(styles.userThumbnail)}>
                <img src={userData.avatar} alt='chat avatar thumbnail' />
              </div>
              <div className={css(styles.displayName)}>
                <h4>{userData.displayName}</h4>
              </div>
            </div>
            <div className={css(styles.messages)}>
              <h2>For Preview Only</h2>
            </div>
            <div className={css(styles.chatForm)}>
              <input type='text' placeholder='Enter your message here' disabled></input>
              <button>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
